import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const NAVY = "#132a63";
const GREEN = "#16a34a";

export default function LoginProveedor() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (!r.ok) return toast.error(r.error);
    if (r.user.role !== "proveedor") { toast.error("Esta cuenta no es de proveedor."); return; }
    navigate("/proveedor");
  };

  return (
    <div style={wrap}>
      <Helmet><title>Acceso Proveedores — Mi Ángel Asís</title></Helmet>
      <div style={card} data-testid="proveedor-login-card">
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{ fontSize: 22, fontWeight: 800, color: NAVY }}>Portal de Proveedores</div>
        </div>
        <form onSubmit={onSubmit}>
          <label style={lbl}>Email</label>
          <input style={inp} type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="pv-login-email" />
          <label style={lbl}>Contraseña</label>
          <input style={inp} type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="pv-login-password" />
          <button type="submit" disabled={loading} data-testid="pv-login-submit"
            style={{ ...btn, background: NAVY, color: "white", marginTop: 18, opacity: loading ? 0.7 : 1 }}>
            {loading ? "Entrando…" : "Entrar"}
          </button>
        </form>
        <div style={{ textAlign: "center", marginTop: 14 }}>
          <Link to="/proveedor/registro" style={{ color: GREEN, fontSize: 13, fontWeight: 700 }} data-testid="pv-go-registro">Registrar mi empresa</Link>
        </div>
      </div>
    </div>
  );
}

const wrap = { minHeight: "100vh", background: NAVY, display: "flex", alignItems: "center", justifyContent: "center", padding: 20, fontFamily: "'Poppins',system-ui,sans-serif" };
const card = { background: "white", color: "#1f2937", borderRadius: 22, padding: "30px 26px", maxWidth: 420, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" };
const lbl = { display: "block", fontSize: 12, fontWeight: 700, color: NAVY, marginBottom: 4 };
const inp = { width: "100%", padding: "11px 13px", borderRadius: 10, border: "1px solid #cbd5e1", fontSize: 15, boxSizing: "border-box" };
const btn = { width: "100%", padding: "13px", borderRadius: 999, fontWeight: 800, border: "none", cursor: "pointer", fontSize: 15 };
